import { render } from "./EditArea.vue?vue&type=template&id=578cd2e1"
import script from "./EditArea.vue?vue&type=script&lang=js"
export * from "./EditArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__